import { render, staticRenderFns } from "./KeysTableThead.vue?vue&type=template&id=fef4065e&scoped=true&"
import script from "./KeysTableThead.vue?vue&type=script&lang=ts&"
export * from "./KeysTableThead.vue?vue&type=script&lang=ts&"
import style0 from "./KeysTableThead.vue?vue&type=style&index=0&id=fef4065e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef4065e",
  null
  
)

export default component.exports